import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { LayoutDirective, LayoutAlignDirective, LayoutGapDirective, FlexDirective } from '@ngbracket/ngx-layout/flex';

@Component({
    selector: 'app-formly-form-flex',
    templateUrl: './formly-form-flex.component.html',
    styleUrl: './formly-form-flex.component.scss',
    imports: [LayoutDirective, LayoutAlignDirective, LayoutGapDirective, FormlyModule, FlexDirective]
})
export class FormlyFormFlexComponent extends FieldType<FieldTypeConfig> {
}
